import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useApiPut } from '@/api/main/query'
import { useToast } from '@/shared/hooks'
import { invalidateAllRequisiteData, useEditRequisit } from '@/features/requisites'
import { usePaymentRequisitActions } from '@/entities/paymentRequisit'
import { requisiteAPI } from '@/features/requisites'
import { ApiError } from '@/api/types'

export const useRequisitPageHandlers = (id: string | undefined, requisitData: any) => {
  const { addToast } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [modalEditRequisitVisible, setModalEditRequisitVisible] = useState(false)
  const [modalDeleteRequisit, setModalDeleteRequisit] = useState(false)
  const [modalDeleteBankcard, setModalDeleteBankcard] = useState(false)
  const [activePaymentRequisit, setActivePaymentRequisit] = useState('')
  const [deletedNameRequisit, setDeletedNameRequisit] = useState('')

  const handleBack = () => navigate(-1)

  const handleSuccess = (message: string) => {
    addToast('Успех!', message, 'success')
    invalidateAllRequisiteData(queryClient, id)
  }

  const handleError = (error: ApiError) => {
    addToast('Ошибка!', error.message, 'error')
  }

  const { handleDeleteRequisit, handleUpdateRequisitSubmit } = useEditRequisit(
    requisitData,
    id,
    () => {
      if (modalDeleteRequisit) {
        setModalDeleteRequisit(false)
        setModalEditRequisitVisible(false)
        handleBack()
      } else {
        setModalEditRequisitVisible(false)
      }
    }
  )

  const { mutate: disableRequisit } = useApiPut(requisiteAPI.disableRequisit(id ?? ''), {
    onSuccess: () => handleSuccess('Реквизит остановлен'),
    onError: handleError,
  })

  const { mutate: enableRequisit } = useApiPut(requisiteAPI.enableRequisit(id ?? ''), {
    onSuccess: () => handleSuccess('Реквизит включен'),
    onError: handleError,
  })

  const { deletePaymentRequisit, disablePaymentRequisit, enablePaymentRequisit } =
    usePaymentRequisitActions(['requisit', id ?? ''], activePaymentRequisit, () => {
      if (modalDeleteBankcard || modalDeleteRequisit) {
        setModalDeleteBankcard(false)
        setModalEditRequisitVisible(false)
      }
    })

  return {
    // Модалки
    modalEditRequisitVisible,
    setModalEditRequisitVisible,
    modalDeleteRequisit,
    setModalDeleteRequisit,
    modalDeleteBankcard,
    setModalDeleteBankcard,
    deletedNameRequisit,
    setDeletedNameRequisit,

    // Реквизиты
    handleDeleteRequisit,
    handleUpdateRequisitSubmit,
    handleEnableRequisit: () => enableRequisit(id),
    handleDisableRequisit: () => disableRequisit(id),
    handleOpenModal: () => setModalEditRequisitVisible(true),

    // Банковские карты
    handleDisableBankcard: (paymentId: string) => {
      setActivePaymentRequisit(paymentId)
      disablePaymentRequisit(paymentId)
    },
    handleEnableBankcard: (paymentId: string) => {
      setActivePaymentRequisit(paymentId)
      enablePaymentRequisit(paymentId)
    },
    handleOpenDeleteDialog: (paymentId: string, name: string) => {
      setDeletedNameRequisit(name)
      setActivePaymentRequisit(paymentId)
      setModalDeleteBankcard(true)
    },
    handleDeleteBankcard: () => {
      deletePaymentRequisit(activePaymentRequisit)
    },
  }
}
